import CONSTANTS from '../../constants';

export function toast(state = null, action) {
  if (action.type === CONSTANTS.ACTIONS.ALERTS.TOAST_SETTINGS) return { toast: action.toast };
  return state;
}
